import React from 'react';

export const AppleIcon: React.FC<{ size?: number; color?: string }> = ({
  size = 16,
  color = 'currentColor',
}) => (
  <svg width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path
      d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.53 4.08l.15-.1zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"
      fill={color}
    />
  </svg>
);

export const GooglePlayIcon: React.FC<{ size?: number }> = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path d="M3.6 2.3c-.3.2-.5.6-.5 1.1v17.2c0 .5.2.9.5 1.1l9.2-9.7L3.6 2.3z" fill="#00D2FF" />
    <path d="M16.4 8.9l-3.6 3.1 3.6 3.1 4.3-2.4c.6-.4.6-1.2 0-1.6l-4.3-2.2z" fill="#FFCE00" />
    <path d="M3.6 2.3l9.2 9.7 3.6-3.1L5.1 1.7c-.6-.3-1.2-.2-1.5.6z" fill="#00F076" />
    <path d="M3.6 21.7c.3.7.9.9 1.5.5l11.3-7.1-3.6-3.1L3.6 21.7z" fill="#FF3A44" />
  </svg>
);

export const AppStoreBadge: React.FC<{ href?: string }> = ({ href = '#' }) => (
  <a className="hp-badge" href={href} target="_blank" rel="noopener noreferrer">
    <AppleIcon size={26} color="#fff" />
    <span className="hp-badge-text">
      <small>Download on the</small>
      <strong>App Store</strong>
    </span>
  </a>
);

export const GooglePlayBadge: React.FC<{ href?: string }> = ({ href = '#' }) => (
  <a className="hp-badge" href={href} target="_blank" rel="noopener noreferrer">
    <GooglePlayIcon size={24} />
    <span className="hp-badge-text">
      <small>GET IT ON</small>
      <strong>Google Play</strong>
    </span>
  </a>
);
